<template>
  <form @submit="validateTCID">
    <div class="alert alert-warning" role="alert">
      Lütfen ad, soyad ve doğum yılı bilgilerinizi kimliğinizde yazdığı şekilde
      giriniz.
    </div>
    <div class="form-group">
      <label for="name">Adınız</label>
      <input
        type="text"
        class="form-control"
        id="name"
        placeholder
        required
        v-model="form.name"
      />
    </div>
    <div class="form-group">
      <label for="lastname">Soyadınız</label>
      <input
        type="text"
        class="form-control"
        id="lastname"
        placeholder
        required
        v-model="form.lastName"
      />
    </div>
    <div class="form-group">
      <label for="birthYear">Doğum Yılınız</label>
      <input
        type="text"
        class="form-control"
        id="birthYear"
        placeholder
        required
        v-model="form.birthYear"
      />
    </div>
    <div class="form-group">
      <label for="inputEmail">Email</label>
      <input
        type="email"
        class="form-control"
        id="inputEmail"
        aria-describedby
        placeholder
        required
        v-model="form.email"
      />
    </div>
    <div class="form-group">
      <label for="tcId">TC Kimlik No</label>
      <input
        type="text"
        class="form-control"
        id="tcId"
        placeholder
        required
        v-model="form.tcId"
      />
    </div>
    <button
      type="submit"
      class="btn btn-info btn-lg float-right"
      style="min-width:120px; margin-top:32px;"
    >
      İleri
    </button>

    <div
      class="modal fade"
      id="tcIdModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Hata!</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            TC Kimlik numaranız girilen bilgilerle uyuşmuyor. Lütfen ad, soyad
            ve doğum yılınızı kimliğinizde yazıldığı şekilde giriniz.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: null,
        name: null,
        lastName: null,
        birthYear: null,
      },
    };
  },
  methods: {
    validateTCID(event) {
      event.preventDefault();
      this.$axios
        .post("/checkTcId", this.form)
        .then((res) => {
          let consentInfo = {
            name: this.form.name,
            lastName: this.form.lastName,
            birthYear: this.form.birthYear,
            tcId: this.form.tcId,
            eventId: this.$root.event.id,
          };
          this.$axios
            .post("/postRegister", consentInfo)
            .then((res) => {
              window.location.href = res.data.eventUrl;
            })
            .catch((error) => {
              if (error.response.data) {
                let status = error.response.data.status;

                if (status == "failed") {
                  $("#tcIdModal").modal("show");
                } else if (status == "smmrequired") {
                  this.$router.push({ name: "smmrequired" });
                }
              }
            });
        })
        .catch((error) => {
          let status = error.response.data.status;
          if (status == "failed") {
            $("#tcIdModal").modal("show");
          }
        });
    },
  },
  created() {
    this.form["tcId"] = this.$root.tcId;
  },
};
</script>

<style>
</style>